module.exports = __webpack_public_path__ + "img/getting-started_banner.cda97d30.jpg";